import { YearCollegeTypeMappingService } from './../../../providers/yearCollegeMapping/year-college-type-mapping.service';
import { EsupportQlmPage } from './../esupport/esupport-qlm/esupport-qlm.page';
import { ESupportPage } from './../esupport/esupport.page';
import { Component, HostListener, OnInit } from '@angular/core';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { Storage } from '@ionic/storage';
import { Location } from '@angular/common';
import { ModalController, NavParams, LoadingController } from '@ionic/angular';
import * as _ from 'lodash';
import { AttachmentService } from 'src/app/providers/forms/attachment/attachment.service';
import { EsupportMappingService } from 'src/app/providers/esupport/esupport-mapping.service';

@Component({
  selector: 'app-naacmetric',
  standalone: false,
  templateUrl: './naacmetric.page.html',
  styleUrls: ['./naacmetric.page.scss'],
})

export class NAACMetricPage implements OnInit {
  metricNumberList = [];
  naacMetricListShowEnable: boolean = false;
  isDisabled: boolean = false;
  previouslySelectedMetrics = [];
  eSupportMapping;
  selectedMetricNumberList = [];
  metricNumbersMapping = [];
  undecidedOption = false;
  naOption = false;
  collegeType = '';
  showQnM: boolean = false;
  showQnMSuggested: boolean = false;
  showQlM: boolean = false;
  showQlMSuggested: boolean = false;
  showSuggested: boolean = true;
  showOther: boolean = false;
  formTypeId;
  form: any = {};
  showCollegeLogo: boolean = true;
  collegeLogo: string | null = null;
  na = {
    "key": "NA",
    "value": "NA",
    "selected": false
  };

  undecided = {
    "key": "Undecided",
    "value": "Undecided",
    "selected": false
  };


  items = [
    {
      "key": "8",
      "value": "Undecided",
      "selected": false
    },
    {
      "key": "9",
      "value": "NA",
      "selected": false
    }
  ]

  constructor(
    public userdataService: UserDataService,
    public storage: Storage,
    public location: Location,
    public modal: ModalController,
    public modalController: ModalController,
    public nvparams: NavParams,
    public attachmentService: AttachmentService,
    public esupportMappingService: EsupportMappingService,
    public loadingController: LoadingController,
    public collegeTypeYearMappingService: YearCollegeTypeMappingService
  ) {
    const selectedNumbers = this.nvparams.get('selectedMetrics');
    this.form = this.nvparams.get('form');
    const uniqueNumbers = [...new Set(selectedNumbers)];
    this.previouslySelectedMetrics = uniqueNumbers;
    this.eSupportMapping = this.nvparams.get('eSupportMapping');
    //console.log(this.previouslySelectedMetrics)
    this.checkMetricsToShow();
  }

  ngOnInit() {

    this.userdataService.getUserProfile().then(profile => {
      this.collegeType = profile.college.collegeType;
      this.fetchAllCollegeTypeForYearFromForCollegeId(profile.college.id)
      //this.loadMetricsForForm(this.collegeType);
    })

  }


  fetchAllCollegeTypeForYearFromForCollegeId(collegeId) {
    this.userdataService.getToken().then(token => {
      this.collegeTypeYearMappingService.fetchCollegeTypeForYearFromAndCollege(token, {
        yearFrom: this.form.yearFrom,
        collegeId: collegeId,
      }).subscribe(response => {
        console.log(response);
        this.collegeType = response ? response.collegeType : "";
        this.loadMetricsForForm(this.form.collegeType);
        /* if(this.yearToCollegeMapping){
          this.yearFromList = this.yearToCollegeMapping.map( mapping =>{
            return mapping.yearFrom;
          })
        } */
      }, error => {

      });
    })
  }

  metricSegmentChanged(ev: any) {
    console.log('Segment changed', ev.target.value);
    if (ev.target.value == "OTHER") {
      this.showSuggested = false;
      this.showOther = true;
    } else {
      this.showSuggested = true;
      this.showOther = false;
    }
  }

  async loadMetricsForForm(collegeType: any) {
    const loader = await this.loadingController.create({
      message: "Getting applicable metric numbers..."
    })
    loader.present();
    this.userdataService.getToken().then(token => {
      if (token) {
        this.esupportMappingService.readNaccMatricDataMapping(token, collegeType)
          .subscribe(naacMetric => {
            if (naacMetric) {
              this.metricNumberList = naacMetric;
              const metricNumbersMapping = [];
              Object.keys(naacMetric).forEach(key => {

                let criterionName = key;
                let metricObject: any = {};
                metricObject.criterion = criterionName;
                metricObject.quantitativeNumbers = naacMetric[key].quantitativeMetricNumbers;
                metricObject.qualitativeNumbers = naacMetric[key].qualitativeMetricNumbers;
                metricNumbersMapping.push(metricObject);
              }
              )
              this.metricNumbersMapping = metricNumbersMapping;

              //console.log(JSON.stringify(metricNumbersMapping, null, 2));
            }
            loader.dismiss();
          });
        this.selectedMetricNumberList = [];
        if (this.previouslySelectedMetrics.length > 0) {
          this.previouslySelectedMetrics.forEach(selectedMetric => {
            this.selectedMetricNumberList.push(selectedMetric);
            if ("Undecided" === selectedMetric) {
              this.undecidedOption = true;
            }
            if ("NA" === selectedMetric) {
              this.naOption = true;
            }
            // selectedMetric.selected = true;
            // if (selectedMetric.key && selectedMetric.key.trim().length > 0) {
            //   this.selectedMetricNumberList.push(selectedMetric.key);
            // }
          })
        }
      }
    });
  }
  // opensubCriterion(criterion){
  //   if(criterion.open){
  //     criterion.open = false;
  //   }else {
  //     criterion.open = true;
  //   }
  // }
  // itemChanged(event,item){
  //   let selected: boolean = event.target.checked;
  //   this.selectedMetricNumberList = []; // Clear out all previous selections
  //   if(selected) {
  //     this.isDisabled = true;
  //     this.selectedMetricNumberList.push(item);
  //     this.clearOutSelection();
  //     this.items.forEach(undecidedOrNA => {
  //       if(undecidedOrNA.value === item.value) {
  //         undecidedOrNA.selected = true;
  //       } else {
  //         undecidedOrNA.selected = false;
  //       }
  //     });
  //   } else {
  //     this.selectedMetricNumberList.forEach(selectedMetric => {
  //       if(selectedMetric.key === "Undecided" || selectedMetric.key === "NA") {
  //         this.isDisabled = true;
  //       } else {
  //         this.isDisabled = false;
  //       }
  //     });
  //     if(this.selectedMetricNumberList.length < 1) {
  //       this.isDisabled = false;
  //     }
  //   }
  // }

  // async clearOutSelection() {
  //   this.metricNumberList.forEach(criterion => {
  //     criterion.subCriterions.forEach(subCriterion => {
  //       subCriterion.subCriterionSubCriterions.forEach(matericNumber => {
  //         matericNumber.selected = false;
  //       });
  //     });
  //   });
  // }

  // undecidedChanged(event) {
  //   let selected: boolean = event.target.checked;
  //   let _this = this;
  //   if(selected) {
  //     this.selectedMetricNumberList = []; // Clear out all previous selections
  //     this.clearOutSelection();
  //     this.isDisabled = true;
  //     this.selectedMetricNumberList.push(this.undecided);
  //     setTimeout(function() {
  //       _this.na.selected = false;
  //     }, 300);
  //   } else {
  //     this.removeSelected(this.undecided);
  //     this.controlDisablingOtherOptions();
  //   }
  // }

  // naChanged(event) {
  //   let selected: boolean = event.target.checked;
  //   let _this = this;
  //   if(selected) {
  //     this.selectedMetricNumberList = []; // Clear out all previous selections
  //     this.clearOutSelection();
  //     this.isDisabled = true;
  //     this.selectedMetricNumberList.push(this.na);
  //     setTimeout(function() {
  //       _this.undecided.selected = false;
  //     }, 300);
  //   } else {
  //     this.removeSelected(this.na);
  //     this.controlDisablingOtherOptions();
  //   }
  // }

  // controlDisablingOtherOptions() {
  //   this.selectedMetricNumberList.forEach(selectedMetric => {
  //     if(selectedMetric.key === "8" || selectedMetric.key === "9") {
  //       this.isDisabled = true;
  //     } else {
  //       this.isDisabled = false;
  //     }
  //   });
  //   if(this.selectedMetricNumberList.length < 1) {
  //     this.isDisabled = false;
  //   }
  // }

  // opensubCriterionOfSubCriterions(subCriterion){
  //   if(subCriterion.open){
  //     subCriterion.open =false;
  //   }else{
  //     subCriterion.open =true;
  //   }
  // }
  // onSelect(metricNumberObj){

  //   if(metricNumberObj.selected){
  //     this.selectedMetricNumberList.push(metricNumberObj);
  //   } else {
  //     this.selectedMetricNumberList.forEach((obj,index) =>{
  //       if(obj.key == metricNumberObj.key){
  //       this.selectedMetricNumberList.splice(index,1);
  //       }
  //     })
  //   }
  // }

  /* ngOnDestroy() {
    if (window.history.state.modal) {
      history.back();
    }
  } */

  backToForm() {
    if (this.form.status.includes("APPROVED")) {
      this.modal.dismiss(this.selectedMetricNumberList, "applied");
    } else {
      this.userdataService.presentToast('Please approve the form first', 'warning');
    }
  }

  dismiss() {
    this.modal.dismiss();
  }

  // removeSelected(metricNumber){
  //   this.selectedMetricNumberList.forEach((obj,index) =>{
  //     if(obj.key == metricNumber.key){
  //      this.selectedMetricNumberList.splice(index,1);
  //     }
  //   })
  // }

  onCheckboxChange(event, number) {
    if (event.target.checked && number) {
      if ('NA' === number) {
        this.selectedMetricNumberList = [];
      }
      this.selectedMetricNumberList.push(number);
    } else {
      this.selectedMetricNumberList.splice(this.selectedMetricNumberList.indexOf(number), 1);
    }

    if (!this.naOption && 'NA' === number) {
      this.undecidedOption = false;
    }
  }

  async openEsupport(metricId, institution) {
    const modal = await this.modalController.create({
      component: ESupportPage,
      componentProps: {
        metricId: metricId,
        institution: institution
      },
      backdropDismiss: false
    })
    modal.present();
  }

  async openQlMEsupport(metricId, institution) {

    const modal = await this.modalController.create({
      component: EsupportQlmPage,
      componentProps: {
        metricId: metricId,
        institution: institution
      },
      backdropDismiss: false
    });

    modal.present();
  }

  checkMetricsToShow() {
    if (this.eSupportMapping.PG || this.eSupportMapping.UG || this.eSupportMapping.AU || this.eSupportMapping.CU || this.eSupportMapping.AC) {
      if (this.eSupportMapping.PG.length > 0 || this.eSupportMapping.UG.length > 0 || this.eSupportMapping.AU.length > 0 || this.eSupportMapping.CU.length > 0 || this.eSupportMapping.AC.length > 0) {
        this.showQnM = true;
      }
      if (this.form.collegeType) {
        if (this.form.collegeType == 'UG' && this.eSupportMapping.UG && this.eSupportMapping.UG.length > 0) {
          this.showQnMSuggested = true;
        }
        if (this.form.collegeType == 'PG' && this.eSupportMapping.PG && this.eSupportMapping.PG.length > 0) {
          this.showQnMSuggested = true;
        }
        if (this.form.collegeType == 'AU' && this.eSupportMapping.AU && this.eSupportMapping.AU.length > 0) {
          this.showQnMSuggested = true;
        }
        if (this.form.collegeType == 'CU' && this.eSupportMapping.CU && this.eSupportMapping.CU.length > 0) {
          this.showQnMSuggested = true;
        }
        if (this.form.collegeType == 'AC' && this.eSupportMapping.AC && this.eSupportMapping.AC.length > 0) {
          this.showQnMSuggested = true;
        }
      }
    }
    if (this.eSupportMapping.qlm != undefined || this.eSupportMapping.qlm != null) {
      if (this.eSupportMapping.qlm.PG.length > 0 || this.eSupportMapping.qlm.UG.length > 0 || this.eSupportMapping.qlm.AU.length > 0 || this.eSupportMapping.qlm.CU.length > 0 || this.eSupportMapping.qlm.AC.length > 0) {
        this.showQlM = true;
      }
      if (this.form.collegeType) {
        if (this.form.collegeType == 'UG' && this.eSupportMapping?.qlm?.UG.length > 0) {
          this.showQlMSuggested = true;
        }
        if (this.form.collegeType == 'PG' && this.eSupportMapping?.qlm?.PG.length > 0) {
          this.showQlMSuggested = true;
        }
        if (this.form.collegeType == 'AU' && this.eSupportMapping?.qlm?.AU.length > 0) {
          this.showQlMSuggested = true;
        }
        if (this.form.collegeType == 'CU' && this.eSupportMapping?.qlm?.CU.length > 0) {
          this.showQlMSuggested = true;
        }
        if (this.form.collegeType == 'AC' && this.eSupportMapping?.qlm?.AC.length > 0) {
          this.showQlMSuggested = true;
        }
      }
    }
  }

}
